/**
 * Device id derived from the messaging identity key (SPEC §9).
 * Peers see our device as the first 16 bytes of our Ed25519 identity key; the
 * value is only ever derived from AUTHENTICATED keys, never read off the wire.
 */

/** 32 lowercase hex chars → 16-byte device id. */
export function messagingDeviceIdHex(messagingPublicKeyHex: string): string {
  const h = messagingPublicKeyHex.replace(/\s+/g, "").toLowerCase();
  if (h.length < 32) {
    throw new Error("messaging public key too short for device id");
  }
  return h.slice(0, 32);
}
